import { render } from "./Card4.vue?vue&type=template&id=aec36072"
import script from "./Card4.vue?vue&type=script&lang=js"
export * from "./Card4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__